import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { z } from 'zod';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import { TLabelCase } from '../types/label-case.type';

export const assignLabelCaseValidationSchema = z.object({
  caseId: z.string().min(1),
  labelIds: z.array(z.string().min(1)).min(1),
});

export type TAssignLabelCaseValidation = z.infer<typeof assignLabelCaseValidationSchema>;
export type TAssignLabelCaseResponse = ApiResponse<TLabelCase>;

export const assignLabelCase = async (data: TAssignLabelCaseValidation): Promise<TAssignLabelCaseResponse> => {
  const url = `/case/label/${data?.caseId}`;

  const dataRequest = {
    labelIds: data?.labelIds,
  };

  return axiosInstance.patch(url, dataRequest);
};

type UseAssignLabelCaseMutationOptions<TContext = unknown> = {
  mutationConfigOptions?: TypedMutationConfig<typeof assignLabelCase, AxiosErrorCustom, TContext>;
};

export const useAssignLabelCaseMutation = <TContext = unknown>({
  mutationConfigOptions,
}: UseAssignLabelCaseMutationOptions<TContext>) => {
  const { ...rest } = mutationConfigOptions || {};

  return useMutation({
    mutationFn: assignLabelCase,
    ...rest,
  });
};
